import state from './storeState'
import mutations from './storeMutations'
import getters from './storeGetters'
import actions from './storeActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
